export const ServiceTypeDecorator = {
  url() {
    return `signup-hubspot/service`;
  },
  query() {
    return {};
  }
};